import React, { useEffect, useState } from "react";
import { Bounce, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useAuth } from "../../../../context/AuthContext";
import classes from "./AddProcessManagement.module.css";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import { env } from "../../../../constants/env";
import QuestionSection from "../../../ui/QuestionSection/QuestionSection";

const questionSets = [
  {
    render: (onAnswerChange, answers, editable) => (
      <>
        <QuestionSection
          number="8.1"
          title="Procedure and/or Process for Continuity and Emergency Preparedness Planning (Contingency Plan)"
          questions={[
            {
              content: (
                <>
                  Has the laboratory defined a procedure and/or process that
                  addresses, but is not limited to, the following activities and
                  measures to address and mitigate the consequences of any event
                  that leads to interruptions of services including but not
                  limited to:
                  <br />
                  Notes: Contingency plans should be periodically tested. Where
                  the laboratory uses another laboratory as a backup, the
                  performance of the back-up laboratory shall be regularly
                  reviewed including contingency plans in the event of failure
                  of the back-up laboratory
                </>
              ),
              hideOptions: true,
            },
            {
              content: "Personnel;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Equipment breakdown;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Power outages;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Stock outs of reagents and consumables;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Fire, natural disasters, e.g., severe weather or floods, bomb threats or civil disturbances",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.2"
          title="Implementation of Continuity and Emergency Preparedness Planning"
          questions={[
            {
              content:
                "Has laboratory management developed and implemented a continuity and emergency preparedness plan covering all laboratory operations (including inputs from risk assessments, internal audits, management reviews, safety audits, etc)",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is the continuity and emergency preparedness plan periodically tested for its continued effectiveness and are actions taken to address any identified gaps?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are there records of monitoring the effectiveness of the continuity and emergency preparedness plan?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Has the continuity and emergency preparedness plan been communicated and training provided to all relevant laboratory personnel?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.3"
          title="Procedure and/or Process for Pre-examination Processes"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content:
                "Location(s) of the laboratory, operating hours, and contact information;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Procedures for requesting and collection of patient samples;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Instructions for collection activities (including sample, volume, and transportation requirements);",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Instructions for pre-collection activities;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Preparation and storage prior to dispatch to the laboratory;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Scope of laboratory activities and time for expected laboratory results;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Time limits and special handling of patient samples;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Patient sample acceptance and rejection criteria;",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Factors known to significantly impact the performance of examinations or interpretation of results;",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Availability of advisory services;",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Requirements for patient consent;",
              number: "k",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Ensuring patient confidentiality;",
              number: "l",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Complaints procedure.",
              number: "m",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.4"
          title="Instructions for Collection Activities"
          questions={[
            {
              content:
                "Are records available to show implementation of the following:",
              hideOptions: true,
            },
            {
              content:
                "Verification of the identity of the patient from whom a primary sample is collected;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Verification and, when relevant, recording that the patient meets preexamination requirements (e.g., fasting status, medication status [time of last dose, cessation], sample collection at predetermined time or time interval);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Collection of primary samples, with descriptions of the primary sample containers and any necessary additives, as well as the order of sample collection, where relevant;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Labelling of primary samples in a manner that provides an unequivocal link with the patient from whom they are collected;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Recording of the identity of the person collecting the primary sample and the collection date, and, when relevant, recording of the collection time;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Requirements for separating or dividing the primary sample, when necessary;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Stabilization and proper storage conditions before collected samples are delivered to the laboratory;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Safe disposal of materials used in the sample collection process",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.5"
          title="Test Request"
          questions={[
            {
              content: (
                <>
                  Does the laboratory adequately collect information needed for
                  examination performance?
                  <br />
                  Note 1: Each request accepted by the laboratory for
                  examination(s) shall be considered an agreement. The request
                  may be paper-based or electronic-based;
                  <br />
                  Note 2: The review of service agreements occurs on sample
                  reception. All portions of the primary sample must be
                  unequivocally traceable to the original primary sample
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Are all test requests accompanied by an acceptable and approved test requisition (e.g., a transmittal sheet/checklist/manifest/request form where applicable)?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Does the request include patient identifiers, including gender, date of birth, location of patient and unique identifier?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Name, initials, and signature (where applicable) of authorized requester;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Type of sample and examination requested;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Clinically relevant information;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Date of sample collection (may include time where appropriate);",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Date and time of sample receipt (pre-analytical);",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Informed consent when required",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.6"
          title="Primary Sample Receipt Procedure"
          questions={[
            {
              content:
                "Does the laboratory implement the sample receipt procedures and are there records of implementation of the following:",
              hideOptions: true,
            },
            {
              content: "Unique patient identifier;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are received samples evaluated according to acceptance and rejection criteria?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are samples logged appropriately upon receipt in the laboratory (including date of receipt, time of receipt, and name of receiving personnel)?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Are procedures in place to process urgent samples?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Are procedures in place to process oral requests?",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "When samples are split, can the portions be traced back to the primary sample?",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are samples delivered to the correct workstations as per the laboratory processes?",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.7"
          title="Pre-examination Handling, Processing and Storage"
          questions={[
            {
              content: (
                <>
                  Prior to testing, are samples handled, processed, and stored
                  according to specific sample type stability and testing
                  requirements?
                  <br />
                  Note: Samples should be stored under the appropriate
                  conditions to maintain the stability of the sample according
                  to international best practice and or testing guidelines
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.8"
          title=" Sample Transportation"
          questions={[
            {
              content:
                "Note: All samples shall be transported to the laboratory in a manner that is safe to patients, users, personnel (including transporters), community and the environment. The laboratory must ensure that the samples were received within a temperature and time interval specified for sample collection",
              hideOptions: true,
            },
            {
              content:
                "Are samples either received at the laboratory or referred to another site, packaged according to national guidelines/regulations?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "When specimens are transported across borders (i.e., internationally) is the packaging and transportation in full compliance with international (e.g., IATA) regulations?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are samples transported within acceptable timeframe and temperature intervals?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are specimens packaged according to national regulations when either received at the laboratory or referred to another site?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.9"
          title="Procedure and/or Process for Referral Laboratories and Technical Consultants"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content:
                "Defining criteria for referral laboratories and technical consultants;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Selection and approval of referral laboratories;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Technical consultants who provide advice and interpretation;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Evaluation and monitoring of the performance of referral laboratories and technical consultants;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Maintenance of a list of approved referral laboratories and technical consultants;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Maintenance of records of referred samples;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Tracking of referred samples and their results;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Reporting of results from referral laboratories;",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Management of critical results received from referral laboratories;",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Packaging and transportation of referred samples;",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Record of communication of results from referral laboratories and technical consultants",
              number: "k",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.10"
          title="Referral Laboratories and Technical Consultants"
          questions={[
            {
              content:
                "Note: The laboratory must have systems in place to ensure that the referral laboratories are competent to perform the services required. Evaluations may be in the form of checking their accreditation status, using a questionnaire, performing audits, use of blinded samples, etc",
              hideOptions: true,
            },
            {
              content:
                "Does the laboratory select referral laboratories and technical consultants based on specific criteria?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are there documented reviews and evaluations of referral laboratories and technical consultants as defined by the laboratory?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is there a register of referral laboratories and technical consultants?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are referred samples tracked properly using a logbook, tracking form or electronically?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Does the laboratory ensure that the results obtained by the referral laboratory are tracked to ensure timely delivery to the user?",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.11"
          title="Procedure and/or Process for Documentation of Examination Procedures"
          questions={[
            {
              content: (
                <>
                  Has the laboratory defined a procedure and/or process that
                  addresses, but is not limited to, the following?
                  <br />
                  Note: Working instructions, job aids, flow process diagrams or
                  similar systems that summarize key information are acceptable
                  for use as a quick reference at the workbench, provided that a
                  fully documented examination procedure (e.g., SOP) is
                  available for reference. Information from product instructions
                  for use can be incorporated into examination procedures by
                  reference in the SOP
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Defining the format, language, and appropriate location of examination procedures;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Selection and approval of referral laboratories",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.12"
          title="Location of Examination Procedures"
          questions={[
            {
              content: (
                <>
                  Are examination information and instructions available in
                  appropriate locations?
                  <br />
                  Note: Examination information and instructions may include
                  SOPs, package inserts, user manuals, job aids, etc
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.13"
          title="Reagents and Consumables Acceptance Testing"
          questions={[
            {
              content: (
                <>
                  Is verification performed and documented before use for each
                  new preparation, new lot, and new shipment of reagents and
                  consumables?
                  <br />
                  Note: Verification can be in-house or based on the Certificate
                  of Analysis of the reagent
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.14"
          title="Procedure and/or Process for Internal Quality Control (IQC)"
          questions={[
            {
              content: (
                <>
                  Has the laboratory defined a procedure and/or process that
                  addresses, but is not limited to, the following?
                  <br />
                  Note: The laboratory should choose concentrations of control
                  materials, wherever possible, especially at or near clinical
                  decision values, which ensure the validity of decisions made.
                  Use of independent third-party control materials should be
                  considered, either instead of, or in addition to, any control
                  materials supplied by the reagent or instrument manufacturer
                </>
              ),
              hideOptions: true,
            },
            {
              content: "Definition of IQC criteria (acceptance and rejection);",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Frequency of processing IQC;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Definition of acceptable ranges (package inserts or in house);",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Use of alternate quality control methods when appropriate quality controls are not available (in-house produced IQC materials, EQA materials, etc.);",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Recording, evaluating, and monitoring ongoing IQC performance;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Troubleshooting unacceptable IQC performance",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.15"
          title="Quality Control"
          questions={[
            {
              content:
                "Is internal quality control performed and verified to be within acceptable limits before testing and release of results?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is corrective action taken and documented when quality control results fall outside the acceptable range and reviews identify nonconformities in a timely manner?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Does the laboratory evaluate the results from patient samples that were examined after the last successful quality control result in the event of a quality control failure?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.16"
          title="Monitoring of Quality Control Performance"
          questions={[
            {
              content:
                "Are quality control results monitored and reviewed to assess the performance of the method and/or identify errors over time for quantitative tests?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is appropriate action taken and documented when there is an error or rule violation with the quality control results?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.17"
          title="Comparability of Examination Results"
          questions={[
            {
              content: (
                <>
                  Does the laboratory compare results to ensure there is no
                  clinically significant variation when the same test for a
                  patient sample is performed with different methods or
                  equipment, including POCT?
                  <br />
                  Note: The laboratory should document and implement a system to
                  ensure there is comparability of results. This could be done
                  using EQA performance, using blinded samples, and parallel
                  testing.
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Does the laboratory record the results of comparability performed and its acceptability?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Does the laboratory periodically review the comparability of results?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Does the laboratory evaluate and act upon the impact of any differences on biological reference intervals and clinical decision limits?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Does the laboratory inform users of any clinically significant differences in comparability of results?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="8.18"
          title="Monitoring and Recording Environmental Conditions"
          questions={[
            {
              content: (
                <>
                  Are the following environmental conditions monitored and
                  recorded daily?
                  <br />
                  Note: The laboratory shall monitor, control, and record
                  environmental conditions, as required by relevant
                  specifications or where it may influence the quality of the
                  sample, results, and/or the safety of patients, visitors,
                  laboratory users, and personnel.
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Room temperatures, including storage areas and all areas involved with testing, e.g., server rooms",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Freezers;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Refrigerators;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Incubators;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Water baths",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="8.19"
          title="Reviewing of Environmental Conditions"
          questions={[
            {
              content:
                "Have acceptable ranges been defined for all environmental conditions?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is there evidence of documentation for action taken in response to unacceptable conditions?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="8.20"
          title="Procedure and/or Process for External Quality Assessment (EQA)"
          questions={[
            {
              content: (
                <>
                  Has the laboratory defined a procedure and/or process that
                  addresses, but is not limited to, the following?
                  <br />
                  Note: The laboratory should choose concentrations of control
                  materials, wherever possible, especially at or near clinical
                  decision values, which ensure the validity of decisions made.
                  Use of independent third-party control materials should be
                  considered, either instead of, or in addition to, any control
                  materials supplied by the reagent or instrument manufacturer
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "All examinations, including POCT, must be enrolled in EQA or alternative methods, in the event EQA is not available;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Defining EQA processing criteria (treating EQA as routine);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Frequency of processing as per the EQA schedule;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Defining acceptable performance criteria;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Use of alternate approaches when the EQA program is not available (e.g., reference materials, blind testing, etc.);",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Recording, evaluating, and monitoring ongoing EQA performance;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Troubleshooting unacceptable EQA performance;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="8.21"
          title="Participation in External Quality Assessment (EQA)"
          questions={[
            {
              content: (
                <>
                  Does the laboratory participate in EQA or external alternative
                  assessment procedures (APP) for all tests?
                  <br />
                  NOTE1: Acceptable alternatives include: • Participation in
                  sample exchanges with other laboratories; • Interlaboratory
                  comparisons of results of examinations of identical IQC
                  materials, which evaluates individual laboratory IQC results
                  against pooled results from participants using the same IQC
                  material, analysis of a different lot number of the
                  manufacturer's end-user calibrator or the manufacturer's
                  trueness control material; • Analysis of microbiological
                  organisms using split / blind testing of the same sample by at
                  least two persons, or on at least two analysers, or by at
                  least two methods; • Analysis of reference materials
                  considered to be commutable with patient samples; • Analysis
                  of patient samples from clinical correlation studies; •
                  Analysis of materials from cell and tissue repositories
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Do EQA or AAP materials come from providers who are approved suppliers?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are EQA or AAP materials handled and tested the same way as routine patient specimens?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is the EQA or AAP performance of the laboratory reviewed and discussed with relevant personnel?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is root cause analysis performed for unacceptable EQA or AAP performance?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is corrective action documented for unacceptable EQA or AAP performance?",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="8.22"
          title="Procedure and/or Process for Verification and Validation of Examinations Methods"
          questions={[
            {
              content: (
                <>
                  Has the laboratory defined a procedure and/or process that
                  addresses, but is not limited to, the following?
                  <br />
                  Note 1: Validations should be done on a) non-standard methods,
                  b) laboratory designed or developed methods, c) standard
                  methods used outside their intended scope, d) validated
                  methods subsequently modified
                  <br />
                  Note 2: ‘Verification’ is performed on methods that are being
                  used without any modifications and is a process of evaluating
                  of whether the procedure meets the performance characteristics
                  stated by the manufacturer, i.e., the manufacturer’s
                  validation claims. The performance characteristics are
                  obtained from the manufacturer (validation reports) or from
                  package inserts. Comparison of different methods used for same
                  tests is ongoing verification. The frequency and
                  characteristics to be checked in ongoing verification must be
                  clearly defined
                  <br />
                  Note 3: All procedures or equipment used as backup must also
                  be validated/verified as relevant.
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Defining the validation or verification protocol (including the authorization for the intended use);",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Performing method validation or verification;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Defining validation or verification report",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="8.23"
          title="Records of Verification of Examination Methods"
          questions={[
            {
              content: (
                <>
                  Note 1: Newly introduced methods must be verified onsite to
                  ensure that their introduction yields performance equal to or
                  better than the manufacturer's claims/specifications
                  <br />
                  Note 2: ‘Verification’ is performed on methods that are being
                  used without any modifications and is a process of evaluating
                  of whether the procedure meets the performance characteristics
                  stated by the manufacturer, i.e., the manufacturer’s
                  validation claims. The performance characteristics are
                  obtained from the manufacturer (validation reports) or from
                  package inserts. Comparison of different methods used for same
                  tests is ongoing verification
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Has the laboratory developed, reviewed, and approved the verification plan (protocol) for each testing method in use prior to verification?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Has the laboratory defined a verification report?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Has the verification report been reviewed by an authorised person?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Has the laboratory generated, reviewed, and approved the verification report for each testing method in use?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are verification records available (including raw data, calculations, etc.)?",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="8.24"
          title="Records of Validation of Examination Methods"
          questions={[
            {
              content:
                "Note: Validations should be done on a) non-standard methods, b) laboratory-designed or -developed methods, c) standard methods used outside their intended scope, d) validated methods subsequently modified",
              hideOptions: true,
            },
            {
              content:
                "Has the laboratory developed, reviewed, and approved the validation plan (protocol) for each testing method in use prior to validation?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Has the laboratory generated, reviewed, and approved the validation report for each testing method in use?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are validation records available (including raw data, calculations, etc.)?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="8.25"
          title="Procedure and/or Process for Measurement Uncertainty (MU)"
          questions={[
            {
              content: (
                <>
                  Has the laboratory defined a procedure and/or process that
                  addresses, but is not limited to, the following?
                  <br />
                  Note: MU is used to indicate the confidence we have that the
                  reported figure is correct. MU may be calculated using the
                  calculated CV of at least 30 sets of internal precision
                  quality control data: CV% x 2 = MU
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Determining MU (analytical error) on measured quantity values (quantitative tests);",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Defining performance requirements for MU",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="8.26"
          title="Measurement Uncertainty of Measured Quantitative Tests"
          questions={[
            {
              content: (
                <>
                  Does the laboratory have documented estimates of MU for each
                  semiquantitative and quantitative test in use?
                  <br />
                  Note: MU should be calculated at different clinical decision
                  limits. Cumulative IQC (minimum 6 months data) may be used to
                  calculate MU
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Has the laboratory calculated MU for each quantitative test in use? Note: If quantitative values are used to decide a qualitative result, then MU must be performed",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Has the laboratory defined the performance requirements (factors that affect MU) for the MU of each measurement examination and does the laboratory regularly review estimates of MU?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Does the laboratory make its calculated MU available to its users upon request?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                " Does the laboratory document reasons for exclusion from MU estimation for examination procedures where evaluation of MU is not possible or relevant?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="8.27"
          title="Procedure and/or Process for Biological Reference Intervals or Clinical Decision Limits"
          questions={[
            {
              content: (
                <>
                  Has the laboratory defined a procedure and/or process that
                  addresses, but is not limited to, the following?
                  <br />
                  Note: The laboratory shall define the biological reference
                  intervals or clinical decision values, document the basis for
                  the reference intervals or decision values and communicate
                  this information to users
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Defining biological reference intervals or clinical decision limits;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Biological reference intervals for examinations that identify presence or absence of a characteristic;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Source of reference intervals or clinical decision limits;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Communication of changes of biological reference intervals or clinical decision limits to users",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        {/* <QuestionSection
          number="7.7"
          title="Management Review of Supply Requests"
          questions={[
            {
              content: (
                <>
                  Does laboratory management review and approve the laboratory's
                  requirements for all externally provided products and
                  services?
                  <br />
                  Note: Since laboratories have different purchasing approval
                  systems, there should be a system in place that the laboratory
                  reviews final approval of their original request
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
        /> */}
      </>
    ),
  },
];

const AddProcessManagement = () => {
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const { user, token } = useAuth();
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const { labId, questionnaireId } = useParams(); // ✅ get questionnaireId too

  const editable = questionnaireId ? status === "Not Attached" : true;

  // --- Prefill answers if editing ---
  useEffect(() => {
    const fetchQuestionnaire = async () => {
      if (!questionnaireId) return; // new form
      try {
        setLoading(true);
        const response = await fetch(
          `${env.kataApiUrl}/api/certification/id/${questionnaireId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to load questionnaire");
        }

        const data = await response.json();

        console.log("DATATAA", data);

        setStatus(data.status);

        const prefilled = {};
        if (data.answers && Array.isArray(data.answers)) {
          data.answers.forEach((ans) => {
            prefilled[ans.questionNumber] = {
              score: ans.score,
              comment: ans.comment,
              points: ans.points,
            };
          });
        }

        setAnswers(prefilled);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestionnaire();
  }, [questionnaireId, token]);

  const handleAnswerChange = (questionNumber, score, comment, points) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionNumber]: {
        score,
        comment,
        points: points ? Number(points) : undefined,
      },
    }));
  };

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet(currentSet + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet(currentSet - 1);
  };

  const submitAssessment = async () => {
    const answersArray = Object.entries(answers).map(
      ([questionNumber, data]) => ({
        questionNumber,
        score: data.score,
        comment: data.comment,
        points: data.points,
      })
    );

    const payload = {
      name: "SLIPTA",
      labId,
      section: "Process Management",
      auditorId: user.id,
      answers: answersArray,
    };

    const url = questionnaireId
      ? `${env.kataApiUrl}/api/certification/id/${questionnaireId}` // edit
      : `${env.kataApiUrl}/api/certification/submit`; // create

    const method = questionnaireId ? "PUT" : "POST";

    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Submission failed");
    }

    return await response.json();
  };

  const handleDone = async () => {
    try {
      if (Object.keys(answers).length === 0) {
        toast.warning("Please answer at least one question before submitting");
        return;
      }

      await submitAssessment();

      toast.success(
        questionnaireId ? "updated successfully!" : "Submitted successfully!"
      );

      navigate(-1);
    } catch (error) {
      toast.error(error.message || "Failed to submit assessment");
    }
  };

  return (
    <div
      className={`${classes.wrapper} ${!editable ? classes.fromParams : ""}`}
    >
      <div
        className="d-flex align-items-center gap-2 mb-4"
        onClick={() => navigate(-1)}
        role="button"
      >
        <IoIosArrowRoundBack size={35} />
        <h2 className="m-0">
          Section 08: Process Management {questionnaireId && "(Editing)"}
        </h2>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {questionSets[currentSet].render(
            handleAnswerChange,
            answers,
            editable
          )}

          {editable && (
            <CommonFooter
              handlePrevious={handlePrevious}
              handleCancel={() => navigate(-1)}
              handleNext={handleNext}
              handleDone={handleDone}
              questionSets={questionSets}
              currentSet={currentSet}
              cancelText="Cancel"
              doneText={
                questionnaireId ? "Update Assessment" : "Submit Assessment"
              }
            />
          )}
        </>
      )}
    </div>
  );
};

export default AddProcessManagement;
